import { Injectable } from "@angular/core";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LimitsReminderConfigService {
	constructor(private configService: ConfigService<any>) {}

	isLimitsReminderEnabled(): boolean {
		return this.configService.get((x) => x.common.limitsReminder.isLimitsReminderEnabled, false);
	}

	// TODO this should be moved to server/src/config
	getLimitsSummaryEndoint(): string {
		return "v1/currentcustomerlimits/summary";
	}
}
